import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class ActivityReportListService {
    url: any;

    constructor(
        private _basewebservice: BaseWebService) { }

    /**
         * Function for get activity list
         */
    activityReportList(filter: any, pageItems: any, offset: any,sortParam: any, order: any, searchKey: any,) {
        this.url = "v1/report/weekly_reports/?";

        if (filter.date_from && filter.date_to && filter.role) {
            this.url = this.url + "date_from=" + filter.date_from + "&date_to=" + filter.date_to + "&role=" + filter.role + "&limit=" + pageItems + "&offset=" + offset;
        } else if (!filter.date_from && !filter.date_to && filter.role) {
            this.url = this.url + "role=" + filter.role + "&limit=" + pageItems + "&offset=" + offset;
        } else if (filter.date_from && filter.date_to && !filter.role) {
            this.url = this.url + "date_from=" + filter.date_from + "&date_to=" + filter.date_to + "&limit=" + pageItems + "&offset=" + offset;
        } else {
            this.url = this.url + "limit=" + pageItems + "&offset=" + offset;
        }

        if (searchKey) {
            this.url = this.url + "&practice_name=" + searchKey;
        }

        if (sortParam && order) {
            this.url = this.url + "&sort=" + sortParam + "&order=" + order;
        }

        return this._basewebservice.request(this.url, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
         * Function for download activity report
         */
    activityReportDownload(id: any) {
        return this._basewebservice.requestBlob("v1/report/weekly_reports/" + id + "/download/", "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}